import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ContentsWrap from 'components/molecules/ContentsWrap';
import Highchart from 'components/organisms/Chart/Highchart';
import PropTypes from 'prop-types';

const BrowserPieGraph = (props) => {
  const { t } = useTranslation();
  const { pieData, loading } = props;

  const pieGraphOption = {
    '01': {
      title: 'Device',
      color: ['#EB483A', '#343434'],
    },
  };

  //하이차트 기본설정
  const graphTitle = t(pieGraphOption['01'].title + ' 별 점유율');
  const initOptions = {
    chart: {
      type: 'pie',
      height: 500,
    },
    title: {
      text: graphTitle,
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      type: 'category',
    },
    accessibility: {
      point: {
        valueSuffix: '%',
      },
    },
    legend: {
      reversed: true,
    },
    tooltip: {
      pointFormatter: function () {
        let point = this;
        let tooltipData = '';
        for (let i = 0; i < point.tooltipData.length; i++) {
          let pointData = point.tooltipData[i].per;
          tooltipData += `${point.tooltipData[i].name} : ${pointData.toFixed(
            2
          )}% <br />`;
        }
        return tooltipData;
      },
      pointFormat: '{point.name}: <b>{point.percentage:.1f}%</b>',
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        //colors: [],
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.percentage:.1f} %',
        },
        showInLegend: true,
      },
    },
    series: [],
  };

  const [graphOption, setGraphOption] = useState(initOptions);

  useEffect(() => {
    if (pieData !== undefined) {
      makeGraphData(pieData.pie);
    } // eslint-disable-next-line
  }, [pieData]);

  /**
   * 그래프용 데이터 가공
   */
  const makeGraphData = useCallback(
    (graphData) => {
      let tmpSeries = [];
      graphData.data.forEach((item) =>
        tmpSeries.push({
          name: item.name,
          y: parseInt(item.val),
          tooltipData: item.tooltipData,
        })
      );
      setGraphOption({
        ...graphOption,
        plotOptions: {
          pie: {
            ...graphOption.plotOptions.pie,
            colors: pieGraphOption['01'].color,
          },
        },
        title: {
          text: graphTitle,
        },
        series: [
          {
            name: 'User',
            colorByPoint: true,
            data: tmpSeries,
          },
        ],
      });
    }, // eslint-disable-next-line
    [graphOption]
  );

  return (
    <>
      <ContentsWrap contentsCount={1} loading={loading}>
        <Highchart options={graphOption} />
      </ContentsWrap>
    </>
  );
};

const equalComparison = (prevProps, nextProps) => {
  if (JSON.stringify(prevProps.params) !== JSON.stringify(nextProps.params)) {
    return false;
  }
};

BrowserPieGraph.propTypes = {
  params: PropTypes.object.isRequired,
};
export default React.memo(BrowserPieGraph, equalComparison);
